import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  useColorModeValue,
  Input,
  TableContainer,
  Checkbox
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import React, { useMemo, useEffect, useState } from "react";
import Pagination from "components/dataDispaly/Pagination";

export default function BranchTable(props) {
  const history = useHistory();
  const {
    columnsData,
    inputCheckbox,
    setCheckbox,
    selectedRows,
    setSelectedRows,
    data,
  } = props;

  const [searchTerm, setSearchTerm] = useState('');
  const [dataBranchFilter, setDataBranchFilter] = useState(data);
  const [pageSize, setDataPageSize] = useState(5);

  const skipPageResetRef = React.useRef(false);
  
  // Handle checkbox selection
  const handleCheckboxChange = (rowValue) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(rowValue)) {
        return prevSelected.filter(value => value !== rowValue);
      } else {
        return [...prevSelected, rowValue];
      }
    });
  };

  // Update filtered data when search term or data changes
  useEffect(() => {
    skipPageResetRef.current = true;
    const dataFilter = data.filter(item => {
      const matchesBranch = item.name_branch &&
        item.name_branch.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesMenu = item.menu_name &&
        item.menu_name.toLowerCase().includes(searchTerm.toLowerCase());

      return matchesBranch || matchesMenu;
    });
    setDataBranchFilter(dataFilter);
    // Reset skip page flag after render
    setTimeout(() => {
      skipPageResetRef.current = false;
    }, 0);
  }, [searchTerm, data]);

  const columns = useMemo(() => columnsData, [columnsData]);

  // Configure table with pagination
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data: dataBranchFilter,
      initialState: { pageIndex: 0, pageSize },
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // Update pageSize when dataPageSize changes
  useEffect(() => {
    setPageSize(pageSize);
  }, [pageSize, setPageSize]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  return (
    <TableContainer>
      <Input
        placeholder="search here..."
        value={searchTerm || ''}
        name="searchTerm"
        onChange={e => setSearchTerm(e.target.value)}
        mb={4}
      />
      <div style={{ maxHeight: '550px', overflowY: 'auto' }}>
        <div style={{ maxWidth: '100px' }}>
          <Text fontSize="xs" mt={3}>Selected Row: {JSON.stringify(selectedRows.sort(), null, 2)}</Text>
        </div>

        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "LIST") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "SELECT") {
                      data = (
                        <Checkbox 
                          size='lg' 
                          isChecked={selectedRows.includes(cell.row.cells[2].value)} 
                          onChange={() => handleCheckboxChange(cell.row.cells[2].value)} 
                        />
                      );
                    } else {
                      data = cell.render("Cell");
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        <Pagination
          canNextPage={canNextPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          gotoPage={gotoPage}
          pageSize={pageSize}
          setDataPageSize={setDataPageSize}
          pageCount={pageCount}
        />
      </div>
    </TableContainer>
  );
}